// eslint-disable-next-line no-restricted-imports -- Intended
import {path} from 'ramda';

import {SourcingVehicleResponseBody} from '@dms/api/core';

export const getVehicleSellerCountry = (vehicleData: SourcingVehicleResponseBody) =>
  path<string>(['seller', 'country', 'key'], vehicleData);
